import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { assert } from "@/common/assert";
import { Contact } from "@/models/Contact";
import BroadsideContact from "./BroadsideContact";
import { currentCmsCompanyId } from "@/common/fhtGlobalEnv";
import { getCustomerSvc, LanguageSettingEnum } from "./broadsideToolUtil";

var BroadsideContactListCms =
/** @class */
function (_super) {
  __extends(BroadsideContactListCms, _super);

  function BroadsideContactListCms(props) {
    var _this = _super.call(this, props) || this;

    _this.getActiveAndInactiveCustomerServices = function () {
      //active cs are instances of Contact
      //inactive cs (never talked to) are of type UserSimpleViewModel
      var isInCms = Boolean(currentCmsCompanyId);
      assert(isInCms, "should be in cms");

      var customerSvcUserIds = _this.state.allCustomerServices.map(function (u) {
        return u.UserId;
      });

      var usersOfCompanyInContacts = _this.props.contacts.filter(function (c) {
        var cid = c.getContactInfo().companyId;
        if (!cid) return false;
        return cid === currentCmsCompanyId;
      });

      var activeCustomerServicesInContacts = usersOfCompanyInContacts.filter(function (u) {
        return customerSvcUserIds.includes(u.user.User.User.UserId);
      });
      var activeCSUserIds = activeCustomerServicesInContacts.map(function (c) {
        return c.user.User.User.UserId;
      });

      var inactiveCS = _this.state.allCustomerServices.filter(function (s) {
        return !activeCSUserIds.includes(s.UserId);
      });

      return inactiveCS.concat(activeCustomerServicesInContacts);
    };

    _this.makeContactList = function (contacts) {
      var contactList;
      contactList = _jsx("ul", __assign({
        className: "broadside-contacts__list"
      }, {
        children: _this.getActiveAndInactiveCustomerServices().map(function (cu) {
          return _jsx("li", __assign({
            className: "broadside-contacts__list-item",
            onClick: function onClick(e) {
              e.preventDefault();

              if (Contact.isContact(cu)) {
                _this.props.onClickContact(cu);
              } else {
                _this.props.onClickInactiveCustomerService(cu);
              }
            }
          }, {
            children: _jsx(BroadsideContact, {
              contact: cu
            }, void 0)
          }), Contact.isContact(cu) ? cu.clientId : cu.ClientId);
        })
      }), void 0);
      return contactList;
    };

    _this.state = {
      allCustomerServices: []
    };
    return _this;
  }

  BroadsideContactListCms.prototype.componentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.getCustomerServiceList()];

          case 1:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BroadsideContactListCms.prototype.getCustomerServiceList = function () {
    return __awaiter(this, void 0, void 0, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            assert(currentCmsCompanyId, "currentCmsCompanyId falsy");
            return [4
            /*yield*/
            , getCustomerSvc(currentCmsCompanyId)];

          case 1:
            res = _a.sent();
            this.setState({
              allCustomerServices: res
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BroadsideContactListCms.prototype.render = function () {
    return _jsx("div", {
      children: this.props.lang === LanguageSettingEnum.Chinese ? _jsxs("div", __assign({
        className: "broadside-contacts"
      }, {
        children: [this.state.allCustomerServices.length ? _jsxs(React.Fragment, {
          children: [_jsxs("div", __assign({
            className: "broadside-contacts__title"
          }, {
            children: ["\u5546\u94FA\u5BA2\u670D\xA0", _jsxs("span", __assign({
              className: "broadside-contacts__cvs-count"
            }, {
              children: [this.state.allCustomerServices.length, "\u4EBA"]
            }), void 0)]
          }), void 0), this.makeContactList(this.props.contacts)]
        }, void 0) : _jsx("span", __assign({
          className: "broadside-contacts__list-item-empty-cms"
        }, {
          children: "\u6682\u65E0\u8054\u7CFB\u4EBA"
        }), void 0), _jsx("span", {
          className: "broadside-tool__arrow broadside-tool__contacts-arrow"
        }, void 0)]
      }), void 0) : _jsxs("div", __assign({
        className: "broadside-contacts"
      }, {
        children: [this.state.allCustomerServices.length ? _jsxs(React.Fragment, {
          children: [_jsxs("div", __assign({
            className: "broadside-contacts__title"
          }, {
            children: ["Contacts:\xA0", _jsx("span", __assign({
              className: "broadside-contacts__cvs-count"
            }, {
              children: this.state.allCustomerServices.length
            }), void 0)]
          }), void 0), this.makeContactList(this.props.contacts)]
        }, void 0) : _jsx("span", __assign({
          className: "broadside-contacts__list-item-empty-cms"
        }, {
          children: "No contacts available"
        }), void 0), _jsx("span", {
          className: "broadside-tool__arrow broadside-tool__contacts-arrow"
        }, void 0)]
      }), void 0)
    }, void 0);
  };

  return BroadsideContactListCms;
}(React.Component);

export default BroadsideContactListCms;